
export const isLocalStorageAvailable = (): boolean => {
  try {
    return typeof window !== 'undefined' && window.localStorage !== undefined;
  } catch {
    return false;
  }
};

export const getLocalStorageItem = (key: string): string | null => {
  if (!isLocalStorageAvailable()) return null;
  
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const setLocalStorageItem = (key: string, value: string): void => {
  if (!isLocalStorageAvailable()) return;
  
  try {
    localStorage.setItem(key, value);
  } catch {
    // Silently fail if localStorage is not available
  }
};

export const removeLocalStorageItem = (key: string): void => {
  if (!isLocalStorageAvailable()) return;
  
  try {
    localStorage.removeItem(key);
  } catch {
    // Silently fail if localStorage is not available
  }
};

export const clearLocalStorage = (): void => {
  if (!isLocalStorageAvailable()) return;
  
  try {
    localStorage.clear();
  } catch {
    // Silently fail if localStorage is not available
  }
};